<template>
  <iModal
    :show-footer="false"
    :visible="isAddToCollectionModalOpen"
    :max-width="550"
    title="Add Link to Collection"
    @close="handleClose"
  >
    <template #body>
      <SelectAffiliateCollection
        v-if="shouldRenderContent"
        :key="shortLinkId"
        :short-link-id="shortLinkId"
      />
    </template>
  </iModal>
</template>

<script>
import { mapWritableState } from "pinia";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";
import SelectAffiliateCollection from "@/components/SelectAffiliateCollection.vue";

export default {
  name: "AddAffiliateLinkToCollectionModal",
  components: {
    SelectAffiliateCollection,
  },
  computed: {
    ...mapWritableState(useAffiliateLinkStore, [
      "affiliateLink",
      "isAddToCollectionModalOpen",
    ]),
    shortLinkId() {
      return this.affiliateLink?.shortLinkId ?? null;
    },
    shouldRenderContent() {
      return this.isAddToCollectionModalOpen && this.shortLinkId !== null;
    },
  },
  methods: {
    handleClose() {
      this.isAddToCollectionModalOpen = false;
      this.affiliateLink = {};
    },
  },
};
</script>
